import { selectedHealingAtom } from "@/store/editor/healing-state"
import { focusedMaskAdjustmentAtom, selectedMaskAtom } from "@/store/editor/masks-state"
import { store } from "@/store/store"

export const clearEditingControlFocus = () => {
	store.set(selectedMaskAtom, null)
	store.set(focusedMaskAdjustmentAtom, null)
	store.set(selectedHealingAtom, null)
}
